import { ArrowLeft, ShieldX } from 'lucide-react'
import { Link } from 'react-router-dom'
import { usePageTitle } from '@/hooks/use-page-title'

export function AccessDeniedPage() {
	usePageTitle('Přístup zamítnut')

	return (
		<div className="min-h-screen flex flex-col bg-white">
			{/* Top bar */}
			<div className="border-b border-gray-200 bg-white">
				<div className="max-w-screen-md mx-auto px-6 py-4 flex items-center">
					<img src="/agnis_logo_crop.png" alt="Agnis" className="h-8" />
				</div>
			</div>

			{/* Main content */}
			<div className="flex-1 flex items-center justify-center px-4 py-12">
				<div className="w-full max-w-md text-center animate-scale-fade">
					<div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-red-50 mb-6">
						<ShieldX className="h-8 w-8 text-red-600" />
					</div>

					<h1 className="text-2xl font-bold tracking-tight text-gray-900">
						Přístup zamítnut
					</h1>
					<p className="text-sm text-gray-500 mt-3 leading-relaxed">
						Nemáte oprávnění přistupovat do administrace Agnis. Tento účet
						není v seznamu povolených administrátorů.
					</p>
					<p className="text-xs text-gray-400 mt-3 leading-relaxed">
						Pokud si myslíte, že jde o chybu, kontaktujte prosím správce
						systému, aby váš e-mail přidal mezi oprávněné uživatele.
					</p>

					<div className="mt-8">
						<Link
							to="/login"
							className="inline-flex items-center justify-center h-11 px-4 rounded-lg border border-gray-300 bg-white text-gray-900 text-sm font-medium hover:bg-gray-50 transition-colors"
						>
							<ArrowLeft className="mr-2 h-4 w-4" />
							Zpět na přihlášení
						</Link>
					</div>
				</div>
			</div>
		</div>
	)
}
